<div class="generalPage" aria-label="help cross referece" role="main">
  <div class="pr-22 content-container pb-0 print-all-content" [ngClass]="IsRightPanel?'pt-0':''">
        <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont pb-heading" role="heading" [innerHTML]="cr_header"></h1>
        <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="cr_desc"></p>
        <p class="answer font-24 content-blue width-100 mb-invert-12 bold" role="heading">{{cr_para1heading}}</p>
        <p class="answer font-16 content-blue width-100" id="cc_para1" (click)="openlink($event)" [innerHTML]="cr_para1body"></p>
        <p class="answer font-24 content-blue width-100 mb-invert-12 bold" role="heading">{{cr_para2header}}</p>
        <p class="answer font-16 content-blue width-100" [innerHTML]="cr_para2body"></p>
      </div>
    </div>

